import { createReducer, on } from '@ngrx/store';
import * as activeMemberActions from './active-member.actions';
import { initialState } from './active-member.state';

export const activeMemberReducer = createReducer(
  initialState,
  on(activeMemberActions.setActiveMemberStateAction, (state, { member }) => ({
    ...state,
    activeMember: { ...member },
  })),
  on(
    activeMemberActions.setMemberCountStateAction,
    (state, { memberCount }) => ({
      ...state,
      memberCount,
    })
  )
);
